import styled from "styled-components";
import LogoImage from "@theme/assets/fairgo-logo.svg";
import React from "react";

const FairGoLogoWrapper = styled.div`
  display: flex;
  align-items: center;
  padding-right: 2em;
  cursor: pointer;
`;

export const FairGoLogo = ({onClick}) => (
  <FairGoLogoWrapper onClick={onClick}>
    <img src={LogoImage} alt="logo"/>
  </FairGoLogoWrapper>
);